export default __webpack_public_path__ + "static/media/done-checkmarkHealthgenom.cd76744e.svg";